import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class ConstructionMethodModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (ConstructionMethodModel._instance == null) ConstructionMethodModel._instance = new ConstructionMethodModel(authManager);
        return ConstructionMethodModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'sites/construction-methods', 'sites/construction-methods/codelist');

        this.entityName = 'sites.ConstructionMethod';
        this.privileges = {
            create: [["adminSites"]],
            read: [["adminSites"],["manageSites"],["editSites"],["readSites"]],
            update: [["adminSites"]],
            delete: [["adminSites"]],
        };

        this.label = 'Construction method';
        this.setLabel = 'Construction methods';

        this.browser = {
            name: 'default-sites-constructionmethod-browser',
            moduleName: 'default-sites-constructionmethod-browser',
            moduleTitle: 'Construction methods',
            moduleStateSlotName: 'default-sites-constructionmethod-browser',
        };

        this.editor = {
            name: 'default-sites-constructionmethod-editor',
            moduleName: 'default-sites-constructionmethod-editor',
            moduleTitle: 'Construction method',
            moduleStateSlotName: 'default-sites-constructionmethod-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
